import { createApi, FetchArgs } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from './baseQueryWithReauth'
import { TagTypes } from './tags'
import {
  SESSION_TAG,
  WISHLIST_TAG,
  CART_TAG,
  ASSET_TAG,
  WO_STATUS_TAG,
  DELIVERY_NOTE_TAG,
  FILES_TAG,
} from './tags'

export const baseApi = createApi({
  tagTypes: [
    SESSION_TAG,
    WISHLIST_TAG,
    CART_TAG,
    ASSET_TAG,
    WO_STATUS_TAG,
    DELIVERY_NOTE_TAG,
    FILES_TAG,
  ] as TagTypes[],
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
})
